import React from "react";
import "./Portfolio.scss";
import Loading from "../../component/Loading";
import CreatePortfolio from "../../component/PortfolioComponents/CreatePortfolio";
import PastTransaction from "../../component/PortfolioComponents/PastTransaction";
import PerformanceAnalysis from "../../component/PortfolioComponents/PerformanceAnalysis";
import TopNav from "../../component/TopNav/TopNav";
import {MDBBox, MDBIcon} from "mdbreact";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";

import SectionHeader from "../../component/SectionHeader/SectionHeader";

import StockChart from "../../component/StockChart";
import HoldingsAndOrders from "../../component/PortfolioComponents/HoldingsAndOrders";
import BottomNav from "../../component/BottomNav/BottomNav";
import {setActivePage, setLoginStep} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import fetchQuery from "relay-runtime/lib/query/fetchQuery";
import PortfolioQuery from "../../queries/PortfolioQuery";
import PortfolioCurrentHoldingQuery from "../../queries/PortfolioCurrentHoldingQuery";
import PortfolioPendingOrderQuery from "../../queries/PortfolioPendingOrderQuery";
import PortfolioPastTransactionQuery from "../../queries/PortfolioPastTransactionQuery";
import PortfolioUserPerformanceQuery from "../../queries/PortfolioUserPerformanceQuery";
import environment from "../../Environment";
import {Fade, Zoom} from "react-reveal";
import BottomModal from "../../component/BottomModal/BottomModal";
import {isNanHandler, NonEmptyArray, numberFormat} from '../../util'
import InviteCard from "../../component/InviteCard/InviteCard";
import StockGraph from "../../component/StockGraph/StockGraph";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";
import Skeleton from "react-loading-skeleton";
import Login from "../Login/Login";

const backgroundCircle = assetUrl + 'images/animation_portfolio_banner_circle.svg'
const briefCase = assetUrl + "images/briefcase.png";
const star = assetUrl + "images/Star.png";
const ruppee = assetUrl + 'images/ruppess_symbol1.png';
const profitLoss = assetUrl + 'images/profit-loss-symbol_large.png'
const pie = assetUrl + "images/performance-analysis-icon.svg";
const PortFolioTransactionIcon = assetUrl + "images/past-transaction-icon.svg";
const SearchIcon = assetUrl + "images/search-icon-white.svg";

class Portfolio extends React.Component {
	state = {
		activeComponent: "main",
		pastTransaction: [],
		portfolio_data: {},
		currentHoldings: [],
		pendingOrders: [],
		performanceModal: false,
		graph_filter: "2week",
		open_modal: false,
		search_text: "",
		filterOrderStatus: '',
		xAxis: [],
		yAxis: [],
		loadingArray: ["loading"],
		graph_loading: false,
		stockOwnedCount: {},
		stockHistoryDetails: [],
		login_modal:false
	}

	componentDidMount() {
		this.props.setActivePage("portfolio");
		this.getAllDatas();
	}
	getAllDatas = () => {
		if(this.props.logged_in){
			this.getPortfolioData();
			this.getCurrentHoldings();
			this.getPendingOrders();
			this.getPastTransactions();
			this.getUserPerformance();
			this.getStockOwnedCount();
			this.getStockHistoryDetails();
		} else {
			this.setState({
				activeComponent: "create"
			})
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.filterOrderStatus !== prevState.filterOrderStatus) {

			this.getPendingOrders();

		}
	}

	setActiveComponent = (args) => {
		this.setState({
			activeComponent: args
		});
	}

	ModalController = () => {
		this.setState({
			performanceModal: !this.state.performanceModal
		})
	}

	filterGraph = (data) => {
		this.setState({
			graph_filter: data,
			xAxis: [],
			yAxis: []
		}, () => {
			this.getUserPerformance();
		});
	}

	getPortfolioData = () => {
		let variable = {}
		this.updateLoading(true);
		fetchQuery(environment, PortfolioQuery, variable)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.userPortfolio !== null) {
					this.setState({
						portfolio_data: response.userPortfolio,
						activeComponent: response.userPortfolio.marketCurrentTotal > 0 ? "main" : "create"
					});
				} else {
					this.setState({
						portfolio_data: {},
						activeComponent: "create"
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					portfolio_data: {},
					activeComponent: "create"
				});
			});
	}
	getStockOwnedCount = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {
					this.setState({
						stockOwnedCount: response.stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: {}
				})
			});
	}
	getStockHistoryDetails = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {

					this.setState({
						stockHistoryDetails: response.stockHistoryDetails
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: []

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: []
				})
			});
	}
	getCurrentHoldings = () => {
		let variable = {
			userId: "",
		}
		// this.updateLoading(true);
		fetchQuery(environment, PortfolioCurrentHoldingQuery, variable)
			.toPromise()
			.then(response => {
				// this.updateLoading(false);
				if (NonEmptyArray(response.userCurrentHoldings)) {

					this.setState({
						currentHoldings: response.userCurrentHoldings.edges
					});
				} else {
					this.setState({
						currentHoldings: []
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					currentHoldings: []
				});
			});
	}

	getPendingOrders = () => {

		let variables = {
			orderStatus: this.state.filterOrderStatus === "PENDING" ? "pending" : this.state.filterOrderStatus === "PARTIALLY_COMPLETED" ? "partially_completed" : ""
		}
		// let variables={
		// 	orderStatus :""
		// }
		// this.updateLoading(true);
		fetchQuery(environment, PortfolioPendingOrderQuery, variables)
			.toPromise()
			.then(response => {
				// this.updateLoading(false);
				if (NonEmptyArray(response.allPendingOrders)) {
					this.setState({
						pendingOrders: response.allPendingOrders.edges
					});
				} else {
					this.setState({
						pendingOrders: []
					});
				}
			}, err => {
				console.log(err);
				// this.updateLoading(false);
				this.setState({
					pendingOrders: []
				});
			});

	}

	getPastTransactions = () => {
		let variable = {
			first: 4
		};
		this.updateLoading(true);
		fetchQuery(environment, PortfolioPastTransactionQuery, variable)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.pastTransactionOrderWise)) {
					this.setState({
						pastTransaction: response.pastTransactionOrderWise.edges
					});
				} else {
					this.setState({
						pastTransaction: []
					});
				}
			}, err => {
				console.log(err);
				this.updateLoading(false);
				this.setState({
					pastTransaction: []
				});
			});
	}

	getUserPerformance = () => {
		let week = 0;
		let day = 0;
		let month = 0;
		if (this.state.graph_filter === "1week") {
			week = 1;
		} else if (this.state.graph_filter === "2week") {
			week = 2;
		} else if (this.state.graph_filter === "1day") {
			day = 1;
		} else if (this.state.graph_filter === "1month") {
			month = 1;
		} else if (this.state.graph_filter === "all") {
			month = 1;
			day = 1;
			week = 1;
		}
		let variables = {
			weeks: week,
			days: day,
			month: month,
			all: this.state.graph_filter === "all"
		}
		this.setState({
			graph_loading: true
		})
		// this.updateLoading(true);
		fetchQuery(environment, PortfolioUserPerformanceQuery, variables)
			.toPromise()
			.then(response => {
				this.setState({
					graph_loading: false
				})
				// this.updateLoading(false);
				if (response.userPerformanceAnalysis !== null && response.userPerformanceAnalysis.length > 0) {
					let xaxis = [];
					let yaxis = [];
					if (response.userPerformanceAnalysis.length === 1) {
						// let temp_xAxis = [response.userPerformanceAnalysis[0].marketCurrentTotal]
						// xaxis = temp_xAxis.flatMap(i=>[i,i,i,i,i])
						// let temp_yAxis = [response.userPerformanceAnalysis[0].created]
						// yaxis = temp_yAxis.flatMap(i=>[i,i,i,i,i])

						// var nowHour = new Date(response.userPerformanceAnalysis[0].created).getHours();
						// for(var i = 0; i < nowHour ; i++){
						// 	let date = new Date(new Date(response.userPerformanceAnalysis[0].created).getTime() - (1000*60*(60*i)));
						// 	xaxis.push(date.toISOString());
						// 	yaxis.push(response.userPerformanceAnalysis[0].marketCurrentTotal);
						// }
						var nowHour = new Date(response.userPerformanceAnalysis[0].created).getHours();
						var startDate = new Date(response.userPerformanceAnalysis[0].created);
						startDate.setDate(startDate.getDate() - 1);
						for (var i = 0; i < nowHour; i++) {
							let date = new Date(new Date(response.userPerformanceAnalysis[0].created).getTime() - (1000 * 60 * (60 * i)));
							if (date.getDate() > startDate.getDate()) {
								xaxis.push(date);
								yaxis.push(response.userPerformanceAnalysis[0].marketCurrentTotal);
							}
						}

					} else {
						for (var i = 0; i < response.userPerformanceAnalysis.length; i++) {
							yaxis[i] = response.userPerformanceAnalysis[i].marketCurrentTotal;
							xaxis[i] = response.userPerformanceAnalysis[i].created;
						}
					}
					this.setState({
						xAxis: xaxis,
						yAxis: yaxis
					})
				} else {
					this.setState({
						xAxis: [],
						yAxis: []
					})
				}
			}, err => {
				// this.updateLoading(false);
				console.log(err);
				this.setState({
					xAxis: [],
					yAxis: [],
					graph_loading: false
				})
			});
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	closeModal = () => {
		this.setState({
			open_modal: false,
		});
	}
	openModel = () => {
		this.setState({
			open_modal: true,
		});
	}

	hangleSearchInput = (e) => {
		this.setState({
			search_text: e.target.value
		}, () => {
			if (e.target.value === "") {
				this.getPastTransactions();
			}
		});
	}

	searchPastTransaction = () => {
		let variable = {
			searchPolitician: this.state.search_text
		};

		this.updateLoading(true);
		fetchQuery(environment, PortfolioPastTransactionQuery, variable)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.pastTransactionOrderWise)) {
					this.setState({
						pastTransaction: response.pastTransactionOrderWise.edges
					});
				} else {
					this.setState({
						pastTransaction: []
					});
				}
			}, err => {
				console.log(err);
				this.updateLoading(false);
				this.setState({
					pastTransaction: []
				});
			});
	}
	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	createNewPortfolio = () => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else {
			this.props.history.push("/all-stocks");
		}
	}

	completeLogin = () => {
		this.closeLoginModal();
		// this.getAllDatas();
		window.location.reload();
	}

	render() {
		const portfolio = "portfolio-";

		const {
			activeComponent,
			pastTransaction,
			portfolio_data,
			currentHoldings,
			pendingOrders,
			performanceModal
		} = this.state;

// console.log("loading ",this.state.loading)
// 		let tempPortfolioValue = 0.14
		return (
			// <Loading loading={this.state.loadingArray.length > 1}>
			<div>
				<div className={portfolio + "main-bg"}>
					{

						activeComponent === "main" ?
							<div>
								<TopNav/>
								<div>
									<div className={'portfolio-main-section pb-0'}>
										<div className={portfolio + "page-index"}>
											<div className={"d-flex justify-content-between align-items-center"}>
												{Object.keys(this.state.portfolio_data).length < 1 ?
													<div className={"d-flex flex-column"}>
														<Skeleton width={"150px"} count={1}/>
														<Skeleton width={"150px"} count={1}/>
														<Skeleton width={"150px"} count={1}/>
													</div>
													:
													// <Fade bottom cascade>

													<div>
														<p className={portfolio + "page-index-fadedText"}>CURRENT
															VALUE</p>
														<p className={portfolio + "page-index-price"}>
															{numberFormat(portfolio_data.marketCurrentTotal)}</p>
														{

															//portfolio_data.percentageDiff
															//tempPortfolioValue
															!(this.state.loadingArray.length > 1) ?
																parseFloat(portfolio_data.percentageDiff) !== 0 &&
																<div className={'d-flex align-items-center'}>
																	<p className={(portfolio + "page-index-stockValue") + (portfolio_data.percentageDiff > 0 ? " positive" : " negative")}>Portfolio
																		Value </p>
																	<div
																		className={"d-flex portfolio-percent-section"}>
																		<p className={("stock-percent") + (portfolio_data.percentageDiff > 0 ? " positive" : " negative")}>{isNanHandler(portfolio_data.percentageDiff)}%</p>
																		{
																			portfolio_data.percentageDiff > 0 ?
																				<MDBIcon icon="caret-up"
																				         style={{color: profit_color}}/> :
																				<MDBIcon icon="caret-down"
																				         style={{color: loss_color}}/>
																		}
																	</div>

																</div> : <Skeleton count={1} width={"100%"}/>
														}

													</div>}
												{/*}*/}
												{/*</Fade>*/}

												{
													Object.keys(this.state.portfolio_data).length > 0?
														<div className={portfolio + "index-imageWrapper"}>
															<img src={backgroundCircle} alt={"alt"}
															     className={portfolio + "index-bg"}/>
															<div className={portfolio + "index-image"}>
																<Fade delay={1000}><img alt={"alt"}
																                        src={briefCase}/></Fade>
															</div>
															<div className={portfolio + "index-starImage"}>
																<Zoom delay={1300}>
																	<img alt={"alt"} src={star}/> </Zoom>
															</div>

														</div> :
														<Skeleton width={"70px"} height={"70px"} circle={true}/>
												}

											</div>
											{/*index card*/}
											{
												Object.keys(this.state.portfolio_data).length < 1 ?
													<Skeleton count={2} width={"100%"}/> :
													<div className={"d-flex align-items-center portfolio-info-section"}>

														{/*<Fade bottom delay={500}>*/}
															<div
																className={portfolio + "page-index-card  d-flex align-items-center"}>
																<div className={"d-flex"}>
																	<img src={ruppee} alt={"alt"}
																	     className={portfolio + "page-index-card-icon"}/>

																</div>

																<div className={portfolio + "page-index-textWrap "}>
																	<p className={portfolio + "page-index-card-price mb-0"}>
																		{numberFormat(portfolio_data.invested)}
																	</p>
																	<p className={portfolio + "page-index-card-subText"}>Invested</p>
																</div>
															</div>

														{/*</Fade>*/}
														<hr className={"vertical-line"}/>
														{/*<Fade bottom delay={800}>*/}
															<div
																className={portfolio + "page-index-card d-flex align-items-center"}>
																<div className={'d-flex'}>
																	<img src={profitLoss} alt={"alt"}
																	     className={portfolio + "page-index-card-icon"}/>
																	{/*<hr className={"vertical-line"}/>*/}
																</div>

																<div className={portfolio + "page-index-textWrap"}>
																	<p className={portfolio + "page-index-card-price mb-0 " + (portfolio_data.profitLoss > 0 ? "positive" : "negative")}>
																		{numberFormat(portfolio_data.profitLoss)}</p>
																	<p className={portfolio + "page-index-card-subText"}>Gain/Loss</p>
																</div>
															</div>
														{/*</Fade>*/}
													</div>
											}

										</div>
										<div className={portfolio + "Performance-chart"}>
											<div>
												<SectionHeader heading={"Performance Analysis"} image={pie}
												               viewmore={false}/>
											</div>
											<div style={{backgroundColor: "#f5f3fb47", borderRadius: "8px"}}
											     className={"stock-graph-section"}>
												{
													this.state.graph_loading ?
														<Skeleton height={200} width={"100%"}/>
														:
														<StockGraph curve={"smooth"}
														            sparkline={false}
														            color={"#AB8EF5"}
														            xaxis={this.state.xAxis}
														            yaxis={this.state.yAxis}
														            graph_filter={this.state.graph_filter}
														            graph_loading={this.state.graph_loading}
														/>
												}

												<MDBBox
													className="d-flex align-items-center justify-content-around graph-filter-container">
													<MDBBox
														className={this.state.graph_filter === "1day" ? "graph-filter-text active" : "graph-filter-text"}
														onClick={() => this.filterGraph("1day")}
													>
														1 Day
													</MDBBox>
													<MDBBox
														className={this.state.graph_filter === "1week" ? "graph-filter-text active" : "graph-filter-text"}
														onClick={() => this.filterGraph("1week")}
													>
														1 Week
													</MDBBox>
													<MDBBox
														className={this.state.graph_filter === "2week" ? "graph-filter-text active" : "graph-filter-text"}
														onClick={() => this.filterGraph("2week")}
													>
														2 Weeks
													</MDBBox>
													<MDBBox
														className={this.state.graph_filter === "1month" ? "graph-filter-text active" : "graph-filter-text"}
														onClick={() => this.filterGraph("1month")}
													>
														1 Month
													</MDBBox>
													<MDBBox
														className={this.state.graph_filter === "all" ? "graph-filter-text active" : "graph-filter-text"}
														onClick={() => this.filterGraph("all")}
													>
														All
													</MDBBox>
												</MDBBox>
											</div>
										</div>
									</div>

									<HoldingsAndOrders
										currentHoldings={currentHoldings}
										pendingOrders={pendingOrders}
										stock_history_details={this.state.stockHistoryDetails}
										stock_owned_count={this.state.stockOwnedCount}
										filterOrderValue={this.state.filterOrderStatus}
										Componentloading={this.state.loadingArray.length > 1}
										filterOrderStatus={(args) => this.setState({filterOrderStatus: args})}
									/>
									<div className={'portfolio-main-section'} style={{backgroundColor: "#FCFBFE"}}>
										<SectionHeader image={PortFolioTransactionIcon}
										               heading={"Past Transactions"} viewmore={true}
										               redirect={"/past-transaction"}/>
										<div className={"search-section"}>
											<div className="input-group">
												<input type="text" className="form-control"
												       placeholder="Search" value={this.state.search_text}
												       onChange={(e) => this.hangleSearchInput(e)}
												/>
												<div className="input-group-append">
													<button className="btn search-btn" type="button"
													        onClick={this.searchPastTransaction}>
														<img src={SearchIcon} alt={"SearchIcon"}/>
													</button>
												</div>
											</div>
										</div>
										<PastTransaction pastTransactionData={pastTransaction}
										                 Componentloading={this.state.loadingArray.length > 1}/>
										{/*invite card*/}
										<div className={"invite-card-section"}>
											<InviteCard/>
										</div>
										{/*<br/>*/}
										{/*<br/>*/}
										{/*<br/>*/}
										{/*<br/>*/}
									</div>
								</div>

							</div>
							:
							activeComponent === "create" ?
								<CreatePortfolio activeComponent={activeComponent}
								                 setActiveComponent={(args) => this.setActiveComponent(args)}
												 createNewPortfolio={this.createNewPortfolio}
								/>

								: null
					}
					{/*<MDBModal isOpen={this.state.open_modal} inline={true} overflowScroll={true}*/}
					{/*		  noClickableBodyWithoutBackdrop={false} toggle={this.ModalController}>*/}
					{/*	<MDBModalBody>*/}
					{/*		<PerformanceAnalysis/>*/}
					{/*	</MDBModalBody>*/}
					{/*</MDBModal>*/}
					<div className={"bottom-space"}/>

					<div className={portfolio + "bottom-nav"}>
						<BottomNav/>
					</div>
				</div>
				<BottomModal
					title={"Performance Analysis"}
					isOpen={this.state.open_modal}
					closeModal={this.closeModal}>
					<PerformanceAnalysis/>
					{/*<div style={{width:"100%",height:"400px"}}>sdfjdsgfkdsf</div>*/}
				</BottomModal>
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</div>
			// </Loading>
		);
	}

}
const mapStateToProps = state => ({
	logged_in: state.UserReducer.logged_in

});
const mapDispatchToProps = dispatch => ({
		setActivePage: data => dispatch
		(
			setActivePage(data)
		),

	}

)

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(Portfolio);
